import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IIntegration, IDisablePayload, IDisbleInput } from './types'
import handleFetchResult from '@utils/handleFetchResult'

const mutateHandler = handleFetchResult<IDisablePayload, IIntegration>({
  handler: (data) => data.deleteIntegration.integration,
  name: 'Integration',
})

export default function disable(input: IDisbleInput): Promise<IIntegration> {
  return client.gql.mutate({ mutation, variables: { input } }).then(mutateHandler)
}

const mutation = gql`
  mutation Disable($input: DeleteIntegrationInput!) {
    deleteIntegration(input: $input) {
      integration {
        id
      }
    }
  }
`
